/* Itz Art — Build 2026 · Modules
   Quick add · rails · hero slider · purple-band parallax · trust quote rotator · recommendations loader.
   Depends on window.ItzShell (itz-shell.js) for the cart. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var currency = root.getAttribute('data-itz-currency') || '$';

  function money(cents) {
    var n = (cents / 100);
    var s = n.toFixed(2).replace(/\.00$/, '');
    return currency + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function sizeLabel(v) {
    // "11x14" / "24 x 36" / "24×36" → "11 × 14"
    return String(v).replace(/\s*[x×]\s*/i, ' × ');
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* =====================================================================================
     Quick add (handoff §4.2) — dependent options: medium first, then only the sizes that exist
     ===================================================================================== */
  var qa = {
    root: $('[data-itz-qa-root]'), panel: $('[data-itz-qa-panel]'), title: $('[data-itz-qa-title]'), thumb: $('[data-itz-qa-thumb]'),
    rating: $('[data-itz-qa-rating]'), from: $('[data-itz-qa-from]'), mediums: $('[data-itz-qa-mediums]'), frames: $('[data-itz-qa-frames]'),
    sizes: $('[data-itz-qa-sizes]'), add: $('[data-itz-qa-add]'), err: $('[data-itz-qa-error]'), loading: $('[data-itz-qa-loading]'),
    mediumLabel: $('[data-itz-qa-medium-label]'), sizeLabel: $('[data-itz-qa-size-label]')
  };
  var qaCache = {}, qaState = null, qaOpener = null;
  var FRAME_SWATCH = { black: '#1A1A1A', white: '#F2F0EB', natural: '#B98A52', oak: '#B98A52', walnut: '#5B3A21', silver: '#C6C8CA', gold: '#B8912F' };

  function splitMedium(value) {
    // "Framed canvas — natural" → family "Framed canvas", colour "natural". Also " - " and " / ".
    var m = String(value).match(/^(.*?)\s+(?:—|–|-|\/)\s+(.*)$/);
    return m ? { family: m[1].trim(), colour: m[2].trim() } : { family: String(value).trim(), colour: '' };
  }
  function mediumIndex(product) {
    var opts = product.options || [];
    var names = opts.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var i = -1;
    names.forEach(function (n, k) { if (i < 0 && /style|medium|material/i.test(n)) i = k; });
    return i < 0 ? 0 : i;
  }
  function sizeIndex(product, mi) {
    var opts = product.options || [];
    var names = opts.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var i = -1;
    names.forEach(function (n, k) { if (i < 0 && k !== mi && /size|dimension/i.test(n)) i = k; });
    if (i < 0) i = mi === 0 ? 1 : 0;
    return names.length > i ? i : -1;
  }
  function optVal(v, i) { return v['option' + (i + 1)]; }

  function buildModel(product) {
    var mi = mediumIndex(product), si = sizeIndex(product, mi);
    var families = [], byFamily = {};
    product.variants.forEach(function (v) {
      var raw = optVal(v, mi) || '';
      var sp = splitMedium(raw);
      if (!byFamily[sp.family]) { byFamily[sp.family] = { name: sp.family, colours: [], variants: [] }; families.push(sp.family); }
      var fam = byFamily[sp.family];
      if (sp.colour && fam.colours.indexOf(sp.colour) < 0) fam.colours.push(sp.colour);
      fam.variants.push({ v: v, colour: sp.colour, size: si >= 0 ? optVal(v, si) : '' });
    });
    return { product: product, mi: mi, si: si, families: families.map(function (f) { return byFamily[f]; }) };
  }
  function familyAvailable(f) { return f.variants.some(function (x) { return x.v.available; }); }
  function rowsFor(model, family, colour) {
    return family.variants.filter(function (x) { return !colour || x.colour === colour; });
  }
  function pickDefault(model) {
    var fam = model.families.filter(familyAvailable)[0] || model.families[0];
    return { family: fam, colour: fam && fam.colours.length ? fam.colours[0] : '', variant: null };
  }

  function renderQa() {
    var s = qaState, m = s.model;
    // Mediums
    qa.mediums.innerHTML = m.families.map(function (f) {
      var on = f === s.family, dead = !familyAvailable(f);
      return '<button type="button" class="itz-opt' + (on ? ' is-selected' : '') + (dead ? ' is-soldout' : '') + '" role="radio" aria-checked="' + on + '" data-itz-qa-family="' + escapeHtml(f.name) + '">' + escapeHtml(f.name) + '</button>';
    }).join('');
    var single = m.families.length <= 1;
    qa.mediums.parentNode.hidden = single && !(m.families[0] && m.families[0].colours.length);
    if (single) qa.mediums.hidden = true; else qa.mediums.hidden = false;
    // Frame colours (folded into the medium option)
    if (s.family && s.family.colours.length > 1) {
      qa.frames.hidden = false;
      qa.frames.innerHTML = s.family.colours.map(function (c) {
        var sw = FRAME_SWATCH[c.toLowerCase()] || '#CCC';
        return '<button type="button" class="itz-frameopt' + (c === s.colour ? ' is-selected' : '') + '" role="radio" aria-checked="' + (c === s.colour) + '" data-itz-qa-colour="' + escapeHtml(c) + '"><span class="itz-frameopt__swatch" style="--swatch:' + sw + '"></span>' + escapeHtml(c.charAt(0).toUpperCase() + c.slice(1)) + '</button>';
      }).join('');
    } else { qa.frames.hidden = true; qa.frames.innerHTML = ''; }
    // Sizes: only the variants that exist for this medium (+ colour). Sold out = muted, never hidden.
    var rows = s.family ? rowsFor(m, s.family, s.colour) : [];
    if (!rows.length) {
      qa.sizes.innerHTML = '<p class="itz-qa__empty">Nothing available in this medium right now.</p>';
    } else {
      qa.sizes.innerHTML = rows.map(function (x) {
        var v = x.v, on = s.variant && s.variant.id === v.id;
        var label = x.size ? sizeLabel(x.size) : v.title;
        return '<button type="button" class="itz-qa__row' + (on ? ' is-selected' : '') + (v.available ? '' : ' is-soldout') + '" role="radio" aria-checked="' + !!on + '" data-itz-qa-variant="' + v.id + '"' + (v.available ? '' : ' aria-disabled="true"') + '>' +
          '<span class="itz-qa__row-label">' + escapeHtml(label) + '</span>' +
          (v.available ? '<span class="itz-qa__row-price">' + money(v.price) + '</span>' : '<span class="itz-qa__row-state">Sold out</span>') + '</button>';
      }).join('');
    }
    if (qa.sizeLabel) qa.sizeLabel.hidden = !rows.length;
    // Mobile add button
    if (s.variant && s.variant.available) { qa.add.disabled = false; qa.add.textContent = 'Add to cart · ' + money(s.variant.price); }
    else { qa.add.disabled = true; qa.add.textContent = 'Choose a size'; }
    qa.err.hidden = true;
  }

  function positionQa() {
    if (mqMobile.matches) { qa.panel.style.cssText = ''; return; }
    var r = qaOpener && qaOpener.closest('[data-itz-card]') ? qaOpener.closest('[data-itz-card]').getBoundingClientRect() : null;
    var w = r ? Math.max(240, Math.round(r.width)) : 280;
    var left = r ? r.left : (window.innerWidth - w) / 2, top = r ? r.top : 80;
    var maxH = window.innerHeight - 32;
    left = Math.min(Math.max(16, left), window.innerWidth - w - 16);
    top = Math.max(16, Math.min(top, window.innerHeight - 16 - Math.min(maxH, 520)));
    qa.panel.style.width = w + 'px'; qa.panel.style.left = left + 'px'; qa.panel.style.top = top + 'px';
  }

  function openQa(handle, opener) {
    if (!qa.root) return;
    qaOpener = opener;
    qa.root.hidden = false; root.classList.add('itz-qa-open');
    if (mqMobile.matches) root.classList.add('itz-locked');
    qa.loading.hidden = false; qa.err.hidden = true; qa.sizes.innerHTML = ''; qa.mediums.innerHTML = ''; qa.frames.hidden = true;
    positionQa();
    var load = qaCache[handle] ? Promise.resolve(qaCache[handle]) : fetch('/products/' + handle + '?section_id=itz-product-json', { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { var m = html.match(/<script[^>]*data-itz-product-json[^>]*>([\s\S]*?)<\/script>/); if (!m) throw new Error('no data'); var p = JSON.parse(m[1]); qaCache[handle] = p; return p; });
    load.then(function (p) {
      var model = buildModel(p);
      qaState = { model: model };
      var d = pickDefault(model); qaState.family = d.family; qaState.colour = d.colour; qaState.variant = null;
      qa.title.textContent = p.title;
      var fi = p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src);
      if (fi && fi.indexOf('//') === 0) fi = 'https:' + fi;
      qa.thumb.innerHTML = fi ? '<img src="' + fi.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x$1$2') + '" alt="">' : '';
      var min = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
      qa.from.textContent = (p.variants.length > 1 ? 'From ' : '') + money(min);
      var card = opener && opener.closest('[data-itz-card]'), rating = card && card.querySelector('.itz-rating');
      if (rating) { qa.rating.innerHTML = rating.innerHTML; qa.rating.hidden = false; } else { qa.rating.hidden = true; }
      qa.loading.hidden = true;
      renderQa();
      positionQa();
      qa.panel.focus({ preventScroll: true });
    }).catch(function () {
      qa.loading.hidden = true; qa.err.hidden = false; qa.err.textContent = 'Could not load this print. Open the product page instead.';
    });
  }
  /* phone: drag the sheet down to close (from the handle/head, or from anywhere when the sheet's own scroll is at the top) */
  (function () {
    if (!qa.panel) return;
    var y0 = null, dy = 0, dragging = false;
    on(qa.panel, 'touchstart', function (e) {
      if (!mqMobile.matches || e.touches.length !== 1) return;
      var fromHead = !!e.target.closest('.itz-qa__grab, .itz-qa__head');
      if (!fromHead && qa.panel.scrollTop > 0) return;
      y0 = e.touches[0].clientY; dy = 0; dragging = true; qa.panel.style.transition = 'none';
    }, { passive: true });
    on(qa.panel, 'touchmove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      if (dy > 0) { qa.panel.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    var end = function () {
      if (!dragging) return; dragging = false;
      qa.panel.style.transition = 'transform 200ms ease';
      if (dy > 90) { qa.panel.style.transform = 'translateY(100%)'; setTimeout(function () { qa.panel.style.transition = ''; qa.panel.style.transform = ''; closeQa(); }, 190); }
      else { qa.panel.style.transform = ''; setTimeout(function () { qa.panel.style.transition = ''; }, 210); }
    };
    on(qa.panel, 'touchend', end); on(qa.panel, 'touchcancel', end);
  })();
  var qaClosing = null;
  function closeQa() {
    if (!qa.root || qa.root.hidden || qaClosing) return;
    var finish = function () {
      qaClosing = null; qa.root.classList.remove('is-closing');
      qa.root.hidden = true; root.classList.remove('itz-qa-open', 'itz-locked');
      if (qaOpener && qaOpener.focus) qaOpener.focus({ preventScroll: true });
      qaOpener = null; qaState = null;
    };
    // mobile: the sheet slides back down before it is removed (itz-sheet-down, 220ms)
    if (mqMobile.matches && !reduced.matches) { qa.root.classList.add('is-closing'); qaClosing = setTimeout(finish, 230); } else { finish(); }
  }
  function addVariant(variant, btn) {
    if (!variant || !variant.available) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add'); }); return r.json(); })
      .then(function () {
        closeQa();
        if (window.ItzShell) { var p = window.ItzShell.refreshCart(); (p && p.then ? p : Promise.resolve()).then(function () { window.ItzShell.openCart(); }); }
      })
      .catch(function (e) { qa.err.hidden = false; qa.err.textContent = e.message || 'Could not add to cart.'; })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  on(doc, 'click', function (e) {
    var opener = e.target.closest('[data-itz-qa]');
    if (opener) { e.preventDefault(); e.stopPropagation(); openQa(opener.getAttribute('data-itz-qa'), opener); return; }
    if (!qa.root || qa.root.hidden) return;
    if (e.target.closest('[data-itz-qa-close]')) { closeQa(); return; }
    var fam = e.target.closest('[data-itz-qa-family]');
    if (fam && qaState) {
      var f = qaState.model.families.filter(function (x) { return x.name === fam.getAttribute('data-itz-qa-family'); })[0];
      if (f) { qaState.family = f; qaState.colour = f.colours.length ? f.colours[0] : ''; qaState.variant = null; renderQa(); }
      return;
    }
    var col = e.target.closest('[data-itz-qa-colour]');
    if (col && qaState) { qaState.colour = col.getAttribute('data-itz-qa-colour'); qaState.variant = null; renderQa(); return; }
    var row = e.target.closest('[data-itz-qa-variant]');
    if (row && qaState) {
      var id = parseInt(row.getAttribute('data-itz-qa-variant'), 10);
      var v = qaState.model.product.variants.filter(function (x) { return x.id === id; })[0];
      if (!v || !v.available) return;
      if (mqMobile.matches) { qaState.variant = v; renderQa(); }
      else { addVariant(v, row); }
      return;
    }
    if (e.target.closest('[data-itz-qa-add]') && qaState) { addVariant(qaState.variant, qa.add); }
  });
  on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeQa(); });
  on(window, 'resize', function () { if (qa.root && !qa.root.hidden) positionQa(); });
  var qaTick = false;
  on(window, 'scroll', function () {
    if (!qa.root || qa.root.hidden || mqMobile.matches || qaTick) return;
    qaTick = true;
    requestAnimationFrame(function () {
      qaTick = false;
      var card = qaOpener && qaOpener.closest('[data-itz-card]');
      if (card) { var r = card.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) { closeQa(); return; } }
      positionQa();
    });
  }, { passive: true });

  /* =====================================================================================
     Rails (handoff §4.8): arrows, drag with threshold (desktop), snap, fade
     ===================================================================================== */
  function initRail(rail) {
    var track = $('[data-itz-rail-track]', rail) || rail;
    var scope = rail.closest('section') || rail.parentNode;
    var prev = $('[data-itz-rail-prev]', scope), next = $('[data-itz-rail-next]', scope);
    function step() { var first = track.children[0]; if (!first) return 300; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24; return (first.getBoundingClientRect().width + gap) * 2; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var fade = $('.itz-rail__fade', rail); if (fade) fade.style.opacity = track.scrollLeft >= max ? '0' : '1';
    }
    on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: reduced.matches ? 'auto' : 'smooth' }); });
    on(next, 'click', function () { track.scrollBy({ left: step(), behavior: reduced.matches ? 'auto' : 'smooth' }); });
    on(track, 'scroll', sync, { passive: true }); on(window, 'resize', sync); sync();
    // Desktop drag: a pan of more than a few px suppresses the card click so panning never navigates
    var x0 = 0, left0 = 0, moved = 0, down = false;
    on(track, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; x0 = e.clientX; left0 = track.scrollLeft;
    });
    on(track, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 6 && !track.classList.contains('is-dragging')) { track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
      if (track.classList.contains('is-dragging')) { moved = Math.max(moved, Math.abs(dx)); track.scrollLeft = left0 - dx; }
    });
    function up(e) {
      if (!down) return; down = false;
      if (track.classList.contains('is-dragging')) {
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
        setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
        var s = step() / 2, target = Math.round(track.scrollLeft / s) * s;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
    on(track, 'pointerup', up); on(track, 'pointercancel', up); on(track, 'pointerleave', up);
    on(track, 'click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  }
  function initRails(scope) { $$('[data-itz-rail]', scope).forEach(function (r) { if (!r.__itz) { r.__itz = true; initRail(r); } }); }
  initRails();

  /* =====================================================================================
     Hero slider (handoff §4.9): crossfade, 7s auto, arrows only, arrows reset the timer
     ===================================================================================== */
  $$('[data-itz-hero]').forEach(function (hero) {
    var slides = $$('[data-itz-hero-slide]', hero), texts = $$('[data-itz-hero-text]', hero);
    if (slides.length < 2) return;
    var i = 0, timer = null, interval = (parseInt(hero.getAttribute('data-interval'), 10) || 7) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      texts.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    function start() { stop(); if (!reduced.matches) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    on($('[data-itz-hero-prev]', hero), 'click', function () { go(i - 1); start(); });
    on($('[data-itz-hero-next]', hero), 'click', function () { go(i + 1); start(); });
    on(doc, 'visibilitychange', function () { doc.hidden ? stop() : start(); });
    start();
  });

  /* =====================================================================================
     Purple band accent parallax (handoff §4.10): ±78px, clamped, desktop only, element removed <768
     ===================================================================================== */
  var bands = [];
  function mountAccents() {
    $$('[data-itz-band], [data-itz-accent-host]').forEach(function (band) {
      var tpl = $('template[data-itz-accent]', band), el = $('[data-itz-parallax]', band);
      if (mqMobile.matches) { if (el) el.remove(); return; }
      if (!el && tpl) { el = tpl.content.firstElementChild.cloneNode(true); tpl.parentNode.insertBefore(el, tpl); }
      if (el && bands.indexOf(band) < 0) bands.push(band);
    });
  }
  var ticking = false;
  function parallax() {
    ticking = false;
    if (mqMobile.matches || reduced.matches) return;
    var vh = window.innerHeight;
    bands.forEach(function (band) {
      var el = $('[data-itz-parallax]', band); if (!el) return;
      var r = band.getBoundingClientRect();
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);  // -1 … 1
      p = Math.max(-1, Math.min(1, p));
      el.style.transform = 'translate3d(0,' + Math.round(-p * 78) + 'px,0)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }
  mountAccents(); parallax();
  on(window, 'scroll', onScroll, { passive: true });
  on(mqMobile, 'change', function () { mountAccents(); parallax(); });

  /* =====================================================================================
     Trust bar quote rotator
     ===================================================================================== */
  $$('[data-itz-quotes]').forEach(function (q) {
    var items = $$('.itz-trust__quote-item', q); if (items.length < 2 || reduced.matches) return;
    var i = 0, ms = (parseInt(q.getAttribute('data-interval'), 10) || 6) * 1000;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
  });

  /* =====================================================================================
     Product recommendations (native) — fetch the section and swap it in
     ===================================================================================== */
  $$('[data-itz-recommendations]').forEach(function (sec) {
    var url = sec.getAttribute('data-url'); if (!url || /product_id=(&|$)/.test(url)) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = doc.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-itz-recommendations]');
      if (inner && inner.children.length) { sec.innerHTML = inner.innerHTML; initRails(sec); } else { sec.remove(); }
    }).catch(function () { sec.remove(); });
  });

  /* ---- Featured tabs (Best sellers / New arrivals over one grid) ------------------------ */
  $$('[data-itz-tabs]').forEach(function (sec) {
    on(sec, 'click', function (e) {
      var t = e.target.closest('[data-itz-tab]'); if (!t) return;
      var n = t.getAttribute('data-itz-tab');
      $$('[data-itz-tab]', sec).forEach(function (b) { var on = b.getAttribute('data-itz-tab') === n; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
      $$('[data-itz-tab-head]', sec).forEach(function (h) { h.classList.toggle('is-active', h.getAttribute('data-itz-tab-head') === n); });
      $$('[data-itz-tab-link]', sec).forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-itz-tab-link') === n); });
      $$('[data-itz-tab-panel]', sec).forEach(function (p) { var on = p.getAttribute('data-itz-tab-panel') === n; p.hidden = !on; p.classList.toggle('is-active', on); });
    });
  });

  /* ---- Families: hovering a row swaps the image on the right --------------------------- */
  $$('[data-itz-families]').forEach(function (sec) {
    function show(n) { $$('[data-itz-family-img]', sec).forEach(function (i) { i.classList.toggle('is-active', i.getAttribute('data-itz-family-img') === n); }); }
    $$('[data-itz-family]', sec).forEach(function (row) {
      on(row, 'mouseenter', function () { show(row.getAttribute('data-itz-family')); });
      on(row, 'focus', function () { show(row.getAttribute('data-itz-family')); });
    });
  });

  /* =====================================================================================
     Collection (handoff §4.6–4.7): filters via Section Rendering, sort, density, load more on
     real ?page= URLs, over-filtered state, mobile sheet. Back button keeps depth + scroll.
     ===================================================================================== */
  $$('[data-itz-collection]').forEach(function (col) {
    var sectionId = col.getAttribute('data-section'), base = col.getAttribute('data-url');
    var form = $('[data-itz-filter-form]', col), openFacet = null, busy = false;
    try { history.scrollRestoration = 'auto'; } catch (_) {}

    function params() {
      var fd = new FormData(form), sp = new URLSearchParams();
      fd.forEach(function (v, k) { if (k === 'sort_by' && !v) return; sp.append(k, v); });
      return sp;
    }
    function urlFor(sp, page) {
      var q = new URLSearchParams(sp); q.delete('page'); if (page && page > 1) q.set('page', page);
      var qs = q.toString(); return base + (qs ? '?' + qs : '');
    }
    function fetchSection(url) {
      var u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      return fetch(u.toString(), { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); });
    }
    function swap(html, keepOpen) {
      var tmp = doc.createElement('div'); tmp.innerHTML = html;
      var next = tmp.querySelector('[data-itz-collection]'); if (!next) return;
      col.innerHTML = next.innerHTML; form = $('[data-itz-filter-form]', col);
      applyDensity(); initRails(col);
      if (keepOpen && openFacet) { var f = $('[data-itz-facet="' + openFacet + '"]', col); if (f) togglePanel(f, true); }
      col.dispatchEvent(new CustomEvent('itz:collection:updated', { bubbles: true }));
    }
    function navigate(url, push) {
      if (busy) return; busy = true; col.classList.add('is-busy');
      var grid = $('[data-itz-grid]', col); if (grid) grid.classList.add('is-loading');
      // the phone sheet lives inside the section: remember whether it was open (and how far it was scrolled) so the re-render does not swap it for a hidden copy while the page stays locked
      var sh = $('[data-itz-sheet]', col), sb = $('[data-itz-sheet-body]', col), sheetWasOpen = !!(sh && !sh.hidden), sheetScroll = sb ? sb.scrollTop : 0;
      fetchSection(url).then(function (html) {
        swap(html, true);
        if (push !== false) history.pushState({ itz: 'collection' }, '', url);
        if (sheetWasOpen) { sheet = $('[data-itz-sheet]', col); if (sheet) { sheet.classList.add('is-instant'); sheet.hidden = false; syncSheet(); var nb = $('[data-itz-sheet-body]', col); if (nb) nb.scrollTop = sheetScroll; } else { root.classList.remove('itz-locked'); } }
        else { syncSheet(); }
      }).catch(function () { location.href = url; }).then(function () { busy = false; col.classList.remove('is-busy'); });
    }

    /* Facet panels — one open at a time, anchored under the pill, clamped to the bar */
    function closePanels() {
      $$('[data-itz-facet]', col).forEach(function (f) { var p = $('[data-itz-facet-panel]', f), b = $('[data-itz-facet-toggle]', f); if (p) p.hidden = true; if (b) b.setAttribute('aria-expanded', 'false'); });
      openFacet = null;
    }
    function togglePanel(facet, force) {
      var panel = $('[data-itz-facet-panel]', facet), btn = $('[data-itz-facet-toggle]', facet);
      if (!panel || !btn) return;
      var open = force != null ? force : panel.hidden;
      closePanels();
      if (!open) return;
      var bar = facet.closest('.itz-fbar__inner') || col;
      var left = btn.getBoundingClientRect().left - bar.getBoundingClientRect().left;
      panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); openFacet = facet.getAttribute('data-itz-facet');
      var w = panel.offsetWidth, max = bar.clientWidth - w;
      panel.style.setProperty('--itz-panel-left', Math.max(0, Math.min(left, max)) + 'px');
    }
    on(col, 'click', function (e) {
      var t = e.target.closest('[data-itz-facet-toggle]');
      if (t) { togglePanel(t.closest('[data-itz-facet]')); return; }
      var st = e.target.closest('[data-itz-sort-toggle]');
      if (st) { var m = $('[data-itz-sort-menu]', col); m.hidden = !m.hidden; st.setAttribute('aria-expanded', String(!m.hidden)); closePanels(); return; }
      var so = e.target.closest('[data-itz-sort-value]');
      if (so) { $('[data-itz-sort-input]', col).value = so.getAttribute('data-itz-sort-value'); navigate(urlFor(params())); return; }
      var d = e.target.closest('[data-itz-density-set]');
      if (d) { setDensity(d.getAttribute('data-itz-density-set')); return; }
      var rm = e.target.closest('[data-itz-remove]');
      if (rm) { e.preventDefault(); var inp = form.querySelector('input[name="' + CSS.escape(rm.getAttribute('data-itz-remove')) + '"][value="' + CSS.escape(rm.getAttribute('data-itz-value')) + '"]'); if (inp) inp.checked = false; navigate(urlFor(params())); return; }
      var cl = e.target.closest('[data-itz-clear]');
      if (cl) { e.preventDefault(); $$('input[type="checkbox"]', form).forEach(function (i) { i.checked = false; }); navigate(urlFor(params())); return; }
      var lm = e.target.closest('[data-itz-load-more]');
      if (lm) { e.preventDefault(); loadMore(lm); return; }
      var so2 = e.target.closest('[data-itz-sheet-open]');
      if (so2) { openSheet(); return; }
      if (e.target.closest('[data-itz-sheet-close]')) { closeSheet(); return; }
    });
    // listeners live on the section wrapper, which survives the re-render; the form element itself is replaced on every swap (a listener bound to it only ever worked for the first tick)
    on(col, 'change', function (e) {
      if (!e.target.closest('[data-itz-filter-form]')) return;
      if (e.target.type !== 'checkbox' || !e.target.name) return;   /* sheet copies have no name: their change is mirrored to the real input, which navigates */
      var lbl = e.target.closest('label'); if (lbl) lbl.classList.toggle('is-selected', e.target.checked);
      navigate(urlFor(params()));
    });
    on(col, 'submit', function (e) { if (e.target.closest('[data-itz-filter-form]')) { e.preventDefault(); navigate(urlFor(params())); } });
    on(doc, 'click', function (e) { if (!e.target.closest('[data-itz-facet]')) closePanels(); if (!e.target.closest('[data-itz-sort]')) { var m = $('[data-itz-sort-menu]', col); if (m && !m.hidden) { m.hidden = true; var b = $('[data-itz-sort-toggle]', col); if (b) b.setAttribute('aria-expanded', 'false'); } } });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape') { closePanels(); closeSheet(); } });
    on(window, 'popstate', function () { if (location.pathname.indexOf(base) === 0) navigate(location.href, false); });

    /* Density: 3 or 4 across, remembered per browser */
    function setDensity(n) { try { localStorage.setItem('itz-density', n); } catch (_) {} applyDensity(); }
    function applyDensity() {
      var n = '4'; try { n = localStorage.getItem('itz-density') || '4'; } catch (_) {}
      var grid = $('[data-itz-grid]', col); if (grid) { grid.classList.toggle('itz-grid--3', n === '3'); grid.classList.toggle('itz-grid--4', n !== '3'); }
      $$('[data-itz-density-set]', col).forEach(function (b) { var on = b.getAttribute('data-itz-density-set') === n; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); });
    }
    applyDensity();

    /* Load more: append the next page, move the URL to ?page=n, keep the numbered links honest */
    function loadMore(btn) {
      if (busy) return; busy = true; btn.setAttribute('aria-busy', 'true');
      var next = btn.getAttribute('data-next');
      fetchSection(next).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var grid = $('[data-itz-grid]', col), items = $$('[data-itz-grid-item]', tmp);
        items.forEach(function (i) { grid.appendChild(i); });
        var more = $('[data-itz-more]', col), nextMore = tmp.querySelector('[data-itz-more]');
        if (more && nextMore) more.innerHTML = nextMore.innerHTML;
        var shown = $('[data-itz-shown]', col);
        if (shown) { var total = parseInt(shown.getAttribute('data-total'), 10); var n = $$('[data-itz-grid-item]', grid).length; shown.textContent = 'Showing ' + Math.min(n, total) + ' of ' + total + ' ' + (shown.textContent.trim().split(' ').pop()); }
        var pageNo = parseInt(new URL(next, location.origin).searchParams.get('page') || '2', 10);
        grid.setAttribute('data-page', pageNo);
        history.replaceState({ itz: 'collection', depth: pageNo }, '', next);
        try { sessionStorage.setItem('itz-depth:' + location.pathname + location.search, String(pageNo)); } catch (_) {}
      }).catch(function () { location.href = next; }).then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    /* Back-button restore: bfcache normally keeps the DOM. When it does not, rebuild pages 1..n-1 above the server-rendered page n. */
    (function restore() {
      var grid = $('[data-itz-grid]', col); if (!grid) return;
      var page = parseInt(grid.getAttribute('data-page') || '1', 10); if (page < 2) return;
      var key = 'itz-depth:' + location.pathname + location.search, depth = 0;
      try { depth = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (_) {}
      if (depth !== page) return;
      var sp = new URLSearchParams(location.search), jobs = [];
      for (var p = 1; p < page; p++) jobs.push(fetchSection(urlFor(sp, p)));
      var y = window.scrollY;
      Promise.all(jobs).then(function (htmls) {
        var frag = doc.createDocumentFragment();
        htmls.forEach(function (h) { var t = doc.createElement('div'); t.innerHTML = h; $$('[data-itz-grid-item]', t).forEach(function (i) { frag.appendChild(i); }); });
        grid.insertBefore(frag, grid.firstChild);
        var shown = $('[data-itz-shown]', col); if (shown) { var total = parseInt(shown.getAttribute('data-total'), 10); shown.textContent = 'Showing ' + Math.min($$('[data-itz-grid-item]', grid).length, total) + ' of ' + total + ' ' + shown.textContent.trim().split(' ').pop(); }
        window.scrollTo(0, y);
      });
    })();

    /* Mobile sheet: every facet open at once, checkboxes are the same set (panels move into the sheet) */
    var sheet = $('[data-itz-sheet]', col);
    function syncSheet() {
      sheet = $('[data-itz-sheet]', col);
      var body = $('[data-itz-sheet-body]', col); if (!sheet || !body || sheet.hidden) return;
      $$('.itz-sheet__facet[data-cloned]', body).forEach(function (n) { n.remove(); });
      $$('[data-itz-facet]', col).forEach(function (f) {
        if (f.closest('[data-itz-sheet]')) return;
        var panel = $('[data-itz-facet-panel]', f); if (!panel) return;
        var wrap = doc.createElement('div'); wrap.className = 'itz-sheet__facet'; wrap.setAttribute('data-cloned', '');
        wrap.innerHTML = '<span class="itz-sheet__label">' + f.getAttribute('data-label') + '</span>';
        var clone = panel.cloneNode(true); clone.hidden = false; clone.removeAttribute('id');
        // keep one live set of inputs: the clone's inputs mirror into the originals on change
        $$('input', clone).forEach(function (ci) { var nm = ci.name; /* captured before the clone's name is blanked, so the mirror still finds the real input */ on(ci, 'change', function () { var o = panel.querySelector('input[name="' + CSS.escape(nm) + '"][value="' + CSS.escape(ci.value) + '"]'); if (o) { o.checked = ci.checked; o.dispatchEvent(new Event('change', { bubbles: true })); } }); ci.name = ''; });
        wrap.appendChild(clone); body.appendChild(wrap);
      });
      var c = $('[data-itz-count-inline]', col), cnt = $('[data-itz-count]', col); if (c && cnt) c.textContent = (cnt.textContent.match(/\d[\d,]*/) || [col.getAttribute('data-count')])[0];   /* the filtered count, not the collection total */
    }
    function openSheet() { sheet = $('[data-itz-sheet]', col); if (!sheet) return; sheet.hidden = false; root.classList.add('itz-locked'); syncSheet(); }
    function closeSheet() { sheet = $('[data-itz-sheet]', col); if (sheet) sheet.hidden = true; root.classList.remove('itz-locked'); }   /* the lock is always released, even if the sheet node was replaced */
  });

  /* Judge.me AI review summary — the Judge.me app block is rendered hidden inside [data-itz-ai-card]; it exposes
     jdgm.data.storeSummaryWidget (ai_summary_text, keywords, number_of_reviews). We paint the theme's own card from it. */
  (function aiSummary() {
    var cards = $$('[data-itz-ai-card]'); if (!cards.length) return;
    var tries = 0;
    function paint() {
      var d = window.jdgm && window.jdgm.data && (window.jdgm.data.storeSummaryWidget || window.jdgm.data.productSummaryWidget);
      if (!d) { if (++tries < 40) return setTimeout(paint, 250); return; }
      var text = (d.ai_summary_text || '').replace(/<[^>]+>/g, '').trim(), kws = (d.keywords || []).map(function (k) { return typeof k === 'string' ? k : (k.keyword || k.text || k.name || ''); }).filter(Boolean);
      if (!text) return;   // Judge.me has not produced a summary yet: the card stays hidden rather than showing a blank
      cards.forEach(function (c) {
        var t = c.querySelector('[data-itz-ai-text]'), th = c.querySelector('[data-itz-ai-themes]'), n = c.querySelector('[data-itz-ai-note]');
        if (t) t.textContent = text;
        if (th) { var cls = th.getAttribute('data-pill-class') || 'itz-pill'; th.innerHTML = kws.slice(0, 6).map(function (k) { return '<span class="' + cls + '">' + escapeHtml(k) + '</span>'; }).join(''); th.hidden = !kws.length; }
        if (n) n.textContent = d.number_of_reviews ? 'Summarised from ' + d.number_of_reviews + ' reviews · updated by Judge.me' : '';
        c.hidden = false;
      });
    }
    paint();
  })();
  window.ItzModules = { openQuickAdd: openQa, closeQuickAdd: closeQa, initRails: initRails, money: money, sizeLabel: sizeLabel };
})();
